(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cambois-devis-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.querySelector('.cb-devis-form');
  if (!form) return;

  var params = new URLSearchParams(window.location.search);

  // Source page (referrer ou ?source=...)
  var sourceInput = form.querySelector('[data-cb-source]');
  if (sourceInput) {
    sourceInput.value = params.get('source') || document.referrer || '';
  }

  // Product referenced (?product=silvia-marble)
  var product = params.get('product');
  if (product) {
    var productInput = form.querySelector('[data-cb-product]');
    if (productInput) productInput.value = product;
    // Prefill description si vide
    var bodyInput = form.querySelector('[name="contact[body]"]');
    if (bodyInput && !bodyInput.value) {
      bodyInput.value = 'Demande relative au produit : ' + product + '\n\n';
    }
  }

  // Material checkbox (?material=pierre)
  var material = params.get('material');
  if (material) {
    var matLower = material.toLowerCase();
    var matMap = {
      'pierre': 'Pierre',
      'stone': 'Pierre',
      'metal': 'Métal',
      'métal': 'Métal',
      'bois': 'Bois',
      'wood': 'Bois'
    };
    var matVal = matMap[matLower];
    if (matVal) {
      var cb = form.querySelector('input[name="contact[materials]"][value="' + matVal + '"]');
      if (cb) cb.checked = true;
    }
  }

  // Role radio (?role=architecte)
  var role = params.get('role');
  if (role) {
    var roleMap = {
      'particulier': 'Particulier',
      'architecte': 'Architecte / Designer',
      'designer': 'Architecte / Designer',
      'installateur': 'Installateur / Poseur',
      'poseur': 'Installateur / Poseur',
      'revendeur': 'Revendeur / Distributeur',
      'distributeur': 'Revendeur / Distributeur'
    };
    var roleVal = roleMap[role.toLowerCase()];
    if (roleVal) {
      var rb = form.querySelector('input[name="contact[project_type]"][value="' + roleVal + '"]');
      if (rb) rb.checked = true;
    }
  }

  // Scroll to success/error message if present
  var msg = form.querySelector('.cb-devis__success, .cb-devis__errors');
  if (msg) {
    setTimeout(function () {
      msg.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cambois-tabs-section"] && !Shopify.designMode) return;
  try {
    
  function cbTabsActivate(root, id) {
    root.querySelectorAll('[data-cb-tab-target]').forEach(function (b) {
      var active = b.dataset.cbTabTarget === id;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    root.querySelectorAll('[data-cb-tab-panel]').forEach(function (p) {
      if (p.dataset.cbTabPanel === id) {
        p.removeAttribute('hidden');
      } else {
        p.setAttribute('hidden', '');
      }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cb-tab-target]');
    if (!btn) return;
    var root = btn.closest('.cb-tabs');
    if (!root) return;
    cbTabsActivate(root, btn.dataset.cbTabTarget);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target.closest ? e.target : null;
    if (!panel || !panel.dataset || !panel.dataset.cbTabPanel) return;
    var root = panel.closest('.cb-tabs');
    if (!root) return;
    cbTabsActivate(root, panel.dataset.cbTabPanel);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
